import React from 'react';
import NocNavBar from '../../../../../../layouts/noc/NocNavBar';
import ExpiredCustomersBody from './ExpiredCustomersBody';

const ExpiredCustomers = () => {
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <NocNavBar currentPage="Expired Customers" />

        <ExpiredCustomersBody />
      </main>
    </div>
  );
};

export default ExpiredCustomers;
